"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleIcon = exports.StyleElement = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
const borderColor = token => ({
  primary: (0, _color.default)('primary'),
  secondary: (0, _color.default)('primary-3'),
  tertiary: (0, _color.default)('primary'),
  quaternary: (0, _color.default)('gray'),
  ghost: 'transparent',
  inactive: (0, _color.default)('gray-3'),
  cancel: (0, _color.default)('gray-2'),
  danger: (0, _color.default)('danger')
})[token || 'primary'];
const backgroundColor = token => ({
  primary: (0, _color.default)('primary'),
  secondary: (0, _color.default)('primary-3'),
  tertiary: 'transparent',
  quaternary: (0, _color.default)('gray'),
  ghost: 'transparent',
  inactive: (0, _color.default)('gray-3'),
  cancel: 'transparent',
  danger: (0, _color.default)('danger')
})[token || 'primary'];
const textColor = token => ({
  primary: (0, _color.default)('white'),
  secondary: (0, _color.default)('primary'),
  tertiary: (0, _color.default)('primary'),
  quaternary: (0, _color.default)('white'),
  ghost: (0, _color.default)('primary'),
  inactive: (0, _color.default)('white'),
  cancel: (0, _color.default)('gray-2'),
  danger: (0, _color.default)('gray-1')
})[token || 'primary'];
const StyleElement = _ref => {
  let {
    tag,
    token,
    size
  } = _ref;
  return (0, _styledComponents.default)(tag).withConfig({
    componentId: "sc-8pk08e-0"
  })(["border:1px solid;border-color:", ";background-color:", ";color:", ";font-weight:bold;font-size:", ";padding:", ";border-radius:8px;transition:opacity 0.3s;display:inline-flex;justify-content:center;line-height:18px;align-items:flex-end;&:disabled{opacity:0.3;}"], borderColor(token), backgroundColor(token), textColor(token), _ref2 => {
    let {
      size
    } = _ref2;
    return size === 'big' ? '1.6rem' : '1.2rem';
  }, _ref3 => {
    let {
      size
    } = _ref3;
    return size === 'big' ? '16px 24px' : '12px 20px';
  });
};
exports.StyleElement = StyleElement;
const StyleIcon = exports.StyleIcon = _styledComponents.default.i.withConfig({
  displayName: "StyleIcon",
  componentId: "sc-8pk08e-1"
})(["", " height:20px;svg{width:20px;height:20px;path{fill:", ";}}"], _ref4 => {
  let {
    iconStart
  } = _ref4;
  return iconStart ? "margin-right: 8px;" : "margin-left: 8px;";
}, _ref5 => {
  let {
    token
  } = _ref5;
  return textColor(token);
});